module.exports = __webpack_public_path__ + "static/GT-Walsheim-Bold-261b20025d02711fec0a2ecf43631019.woff";